import { Message } from 'view-design'
import axios from 'axios';
import qs from 'qs';
import md5 from 'js-md5';
import { getToken, removeLoginUser } from "../utils/localStorage";

Message.config({ top: 100, duration: 3 });

let ajax = {
    baseUrl: process.env.VUE_APP_API_URL,
    extractUrl: function (url) {
        return url ? url.split('?')[0] : '';
    },
    requestingApi: new Set(),
    isRequesting: function (url) {
        let api = this.extractUrl(url);
        return this.requestingApi.has(api);
    },
    addRequest: function (url) {
        let api = this.extractUrl(url);
        this.requestingApi.add(api);
    },
    deleteRequest: function (url) {
        let api = this.extractUrl(url);
        this.requestingApi.delete(api);
    },
    setSign: function (data) {
        if (!data) return;
        const key = process.env.VUE_APP_KEY;
        if (!data.hasOwnProperty('ts')) {
            const ts = (new Date()).valueOf();
            data.ts = ts;
        }
        let signData = Object.keys(data).sort().map((key) => {
            return `${key}=${data[key]}`;
        }).join("&");
        let sign = md5(`${signData}${key}`);
        data.sign = sign;
    },
    get: function (url, data, param) {
        let params = Object.assign({ url, method: 'GET' }, param);
        this.setSign(data);
        return this.ajax(data, params);
    },
    post: function (url, data, param) {
        let params = Object.assign({ url, method: 'POST' }, param);
        this.setSign(data);
        let datas = qs.stringify(data);
        return this.ajax(datas, params);
    },
    down: function (url, data, param) {
        let params = Object.assign({ url, method: 'POST', responseType: 'blob' }, param);
        this.setSign(data);
        let datas = qs.stringify(data);
        return this.ajax(datas, params);
    },
    ajax: function (data, extendParam) {

        let url = extendParam.url;
        if (extendParam.method != 'GET') {
            if (this.isRequesting(url) && url!=='/api/pc/scoringMethod') {
                return new Promise((resolve) => { resolve({ status: 0, message: '重复请求' }) })
            }
            if (extendParam.repeatable === false || typeof (extendParam.repeatable) === "undefined") {
                this.addRequest(url);
            }
        }

        //授权验证处理
        let defaultHeader = {
            Authorization: 'Beego aHVhaGFuOmJlZWdvMjAxNQ=='
        }
        let authToken = getToken();
        if (authToken) {
            if (authToken.preAuth && !authToken.nextAuth) {
                defaultHeader.token = `${authToken.preAuth}`;
            }
            if (authToken.nextAuth) {
                defaultHeader.token = `${authToken.nextAuth}`;
                //defaultHeader.token = 'sadfasdfsadfasdfasdf';
            }
        }

        let headers = Object.assign(defaultHeader, extendParam.headers);

        let requestParam = {
            headers,
            responseType: extendParam.responseType,
            paramsSerializer: (params) => {
                return qs.stringify(params, { allowDots: true });
            },
            method: extendParam.method,
            baseURL: this.baseUrl,
            url: extendParam.url,
            params: extendParam.method === 'GET' || extendParam.method === 'DELETE' ? data : null,
            data: extendParam.method === 'POST' || extendParam.method === 'PUT' ? data : null,
        }
        return new Promise((resolve) => axios.request(requestParam).then((response) => {
            this.deleteRequest(url);
            let status = response.status;
            //alert(status);
            if (status == 200) {
                let result = response.data;
                //console.log(result);
                status = result.status;
                if (status == 403) {
                    // Message.error({ content: '登录已失效，请重新登录', background: true, closable: true });
                    Message.error({ content: result.message, background: true, closable: true });
                    removeLoginUser();
                    setTimeout(() => {
                        window.top.location = '/login';
                    }, 3000)
                    return;
                }
                resolve(result);
            }
        }).catch((error) => {
            this.deleteRequest(url);
            console.log(error);
            resolve({ status: 0, message: '网络请求失败', data: '' });
        }))
    },
    download: function (filename, data) {
        if (!data) return;
        var url = window.URL.createObjectURL(new Blob([data]))
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }
}

export default ajax